if (!customElements.get('collapsible-tab')) {
  customElements.define('collapsible-tab', class CollapseTab extends HTMLElement {
    constructor() {
      super();
      console.log('swdfdfd');
      
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.collapsibleContent = this.querySelector('.collapsible-content');
      this.button.addEventListener('click', this.toggle.bind(this));
      this.isOpen = this.collapsibleContent.getAttribute('aria-hidden') === 'false';

      if (this.isOpen) {
        this.collapsibleContent.style.height = this.collapsibleContent.scrollHeight + 'px';
      }
    }
  
    toggle() {
      if (this.isOpen) {
        this.collapsibleContent.style.height = '0px';
        this.collapsibleContent.setAttribute('aria-hidden', 'true');
        this.isOpen = false;
        this.toggleAttribute('open')
        this.classList.remove('collapse_open');
      } else {
        this.collapsibleContent.style.height = this.collapsibleContent.scrollHeight + 'px';
        this.collapsibleContent.setAttribute('aria-hidden', 'false');
        this.isOpen = true;
        this.toggleAttribute('open')
        this.classList.add('collapse_open');
      }
    }
  });
}



